module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-event/gatsby-browser.js'),
      options: {"plugins":[],"dontCreatePages":true},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-producer-profile/gatsby-browser.js'),
      options: {"plugins":[],"rootPath":"/de","locale":"de"},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-producer-profile/gatsby-browser.js'),
      options: {"plugins":[],"rootPath":"/en","locale":"en"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
